// import Vue from 'vue'
import consts from "@/consts"
import {diffObjects, getApiProps} from "@/lib/lib";
import range from "lodash/range";

export default {
    state: {
        videoStatusesFullLoad: false,
        video_statuses: [],
    },
    actions: {
        fetchVideoStatuses/*all*/({ dispatch, getters }, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchVideoStatuses', args, time: Date.now() / 1000})

                const params = getApiProps('video_status', args)
                this.$api.videoStatuses.getAll(params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response.data)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchVideoStatuses', args, inprogress: false})
                    });
            })
        },
        fetchVideoStatusesChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken) {
                return Promise.resolve(null)
            }
            dispatch('setLastCall', {name: 'fetchVideoStatusesChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchVideoStatuses', args)
                .then((data) => {
                    commit('updateVideoStatuses', data)
                })
                // .then((data) => {
                //     commit('filterVideoStatuses', data)
                // })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchVideoStatusesChanged', args, inprogress: false})
                });
        },
        fetchVideoStatusesAll({dispatch}, args) {
            // dispatch('setLastCall', {name: 'fetchVideoStatus', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchVideoStatusesAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchVideoStatusesChanged', args, time: Date.now() / 1000})

            return dispatch('fetchVideoStatusesAllPages', args)
                .finally(() => {
                    // dispatch('setLastCall', {name: 'fetchVideoStatus', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchVideoStatusesAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchVideoStatusesChanged', args, inprogress: false})
                });
        },
        fetchVideoStatusesAllPages({dispatch, commit, getters}, args) {
            dispatch('setLastCall', {name: 'fetchVideoStatusesChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(null)
                }
                if (!getters.getUnits.length) {
                    return resolve([])
                }

                let pageSize = consts.querySettings.pageSize
                let pages = Math.ceil(getters.getUnitsHasVideo.length / pageSize)
                let fetch = range(pages).map(i => {
                    let page = i + 1;
                    return dispatch('fetchVideoStatuses', {page, 'page-size': pageSize, ...args})
                        .then((data) => {
                            commit('updateVideoStatuses', data)
                        })
                        .catch(() => {
                            //dispatch('fetchVideoStatuses', {page, 'page-size': pageSize, ...args})
                        })
                });
                resolve(fetch)
            })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setVideoStatusesFullLoad', true)
                        })
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchVideoStatusesAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchVideoStatusesChanged', args, inprogress: false})
                });
        },
        fetchGroupVideoStatuses({ commit, dispatch, getters }, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.groupId) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchGroupVideoStatuses', args, time: Date.now() / 1000})

                let params = getApiProps('video_status', args)
                delete params.groupId
                this.$api.videoStatuses.forGroup(args.groupId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response.data)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchGroupVideoStatuses', args, inprogress: false})
                    });
            })
            .then((data) => {
                commit('updateVideoStatuses', data)
            })
        },
        fetchVideoStatus({ commit, dispatch, getters }, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.unitId || !getters.isUnitsLiteLoad || !getters.isUnitsLmsgsLiteLoad) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchVideoStatus', args, time: Date.now() / 1000})

                let params = getApiProps('video_status', args)
                delete params.unitId;
                this.$api.videoStatuses.forUnit(args.unitId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateVideoStatus', response.data)
                        } else {
                            reject(response.data)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchVideoStatus', args, inprogress: false})
                    });
            })
                .then((data) => {
                    commit('updateVideoStatus', data)
                })
        },

    },
    mutations: {
        setVideoStatusesFullLoad(state, FullLoad) {
            state.videoStatusesFullLoad = state.videoStatusesFullLoad || FullLoad
        },
        updateVideoStatuses(state, nVideoStatuses) {
            if(!state.video_statuses.length) {
                state.video_statuses = nVideoStatuses.map(vs => Object.freeze(vs))
                return true
            }

            nVideoStatuses.forEach(function (nVideoStatus) {
                let i = state.video_statuses.findIndex(vs => (vs.unit_id == nVideoStatus.unit_id))
                if(i<0) {
                    state.video_statuses.push(Object.freeze(nVideoStatus))
                }else{
                    // updateObjectByDiff(state.video_statuses[i], nVideoStatus)
                    nVideoStatus = diffObjects(state.video_statuses[i], nVideoStatus)
                    if(nVideoStatus) state.video_statuses[i] = Object.freeze({...state.video_statuses[i], ...nVideoStatus})
                }
            })
        },
        updateVideoStatus(state, nVideoStatus) {
            let i = state.video_statuses.findIndex(vs => (vs.unit_id == nVideoStatus.unit_id))
            if(i<0) {
                state.video_statuses.push(Object.freeze(nVideoStatus))
            }else{
                // updateObjectByDiff(state.video_statuses[i], nVideoStatus)
                nVideoStatus = diffObjects(state.video_statuses[i], nVideoStatus)
                if(nVideoStatus) state.video_statuses[i] = Object.freeze({...state.video_statuses[i], ...nVideoStatus})
            }
        },
        deleteVideoStatus(state, unit_id) {
            let i = state.video_statuses.findIndex(vs => (vs.unit_id == unit_id))
            if(i != -1) {
                state.video_statuses.splice(i, 1)
            }
        },
        reloadVideoStatusesAll({commit, dispatch}, args) {
            commit('clearVideoStatuses')
            return dispatch('fetchVideoStatusesAll', args)
        },
        clearVideoStatuses(state) {
            state.video_statuses = []
            state.videoStatusesFullLoad = false
        }
    },
    getters: {
        isVideoStatusesFullLoad(state){
            return state.videoStatusesFullLoad
        },
        getVideoStatuses(state){
            return state.video_statuses
        },
        getVideoStatusesByUnitsIds(state){
            // return state.video_statusesObj
            return state.video_statuses.reduce((video_statusesById, video_status) => {
                video_statusesById[video_status.unit_id] = video_status
                return video_statusesById
            }, {})
        },
        getVideoStatusesErrors(state){
            return state.video_statuses.filter(s => s?.errors?.length)
        },
        getVideoStatusesByTypes(state){
            // return state.video_statusesObj
            return state.video_statuses.reduce((video_statusesById, video_status) => {
                video_statusesById[video_status.hw_type] = video_status
                return video_statusesById
            }, {})
        },
    }
}
